"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genOpenWithNewPageLink = exports.webLink = exports.generateAddress = exports.languageCode = exports.isFromEzbuyint = exports.isFromEzbuyapp = exports.convertToMobileLink = exports.isCateegory = exports.isWeb = exports.isEzbuyAppProtocol = void 0;
var ssrcontext_1 = require("ssrcontext");
var ezbuyappRegex = /^ezbuyint:\/\/(\w+)(?:\/([\w\d]+))?(?:\?([\w\W]+))?$/i;
exports.isEzbuyAppProtocol = function (protocolLink) {
    return ezbuyappRegex.test(protocolLink);
};
var parse = function (protocolLink) {
    var ret = null;
    var res = ezbuyappRegex.exec(protocolLink);
    if (res !== null) {
        ret = {
            hostname: res[1]
        };
        if (typeof res[2] !== "undefined") {
            ret.pathname = res[2];
        }
        if (typeof res[3] !== "undefined") {
            ret.query = res[3].split("&").reduce(function (pValue, cValue) {
                var _a = cValue.split("="), key = _a[0], value = _a[1];
                if (typeof key !== "undefined" && typeof value !== "undefined") {
                    pValue[key] = decodeURIComponent(value);
                }
                return pValue;
            }, {});
        }
    }
    return ret;
};
exports.isWeb = function (hostname) { return hostname.toLowerCase() === "web"; };
exports.isCateegory = function (hostname) { return hostname.toLowerCase() === "category"; };
exports.convertToMobileLink = function (link) {
    var protocol = parse(link);
    if (protocol !== null) {
        var _a = parse(link), hostname = _a.hostname, query = _a.query;
        if (exports.isWeb(hostname)) {
            return query["url"];
        }
        else if (exports.isCateegory(hostname)) {
            return "/search?categoryId=" + query["id"];
        }
    }
    return link;
};
exports.isFromEzbuyapp = function () {
    return (ssrcontext_1.getUserAgent()
        .toLowerCase()
        .indexOf("ezbuyapp") !== -1);
};
exports.isFromEzbuyint = function () {
    return (ssrcontext_1.getUserAgent()
        .toLowerCase()
        .indexOf("ezbuyint") !== -1);
};
var clientUAParams = (function () {
    var regex = /\[((?:[\w\d]+\/[\w\d\.\s-=,]+;?)+)\]$/i;
    var result = regex.exec(ssrcontext_1.getUserAgent());
    var ret = {};
    if (result !== null) {
        return result[1].split(";").reduce(function (pValue, cValue) {
            var arrs = cValue.split("/");
            if (arrs.length > 1) {
                pValue[arrs[0]] = arrs.slice(1).join("");
            }
            return pValue;
        }, ret);
    }
    return ret;
})();
exports.languageCode = "" + clientUAParams["Language"];
exports.generateAddress = function generateAddress(host, params) {
    var paramStr = "";
    var paramStrArray = [];
    for (var key in params) {
        if (typeof params[key] !== "undefined") {
            paramStrArray.push(encodeURIComponent(key) + "=" + encodeURIComponent(params[key]));
        }
    }
    if (paramStrArray.length > 0) {
        paramStr = "?" + paramStrArray.join("&");
    }
    if (exports.isFromEzbuyapp()) {
        return "ezBuyApp://" + host + paramStr;
    }
    else if (exports.isFromEzbuyint()) {
        return "ezbuyint://" + host + paramStr;
    }
};
exports.webLink = function (url, title, openMode, searchDomain) {
    return exports.generateAddress("web", { url: url, openMode: openMode, title: title, searchDomain: searchDomain });
};
exports.genOpenWithNewPageLink = function (url, title, openMode, searchDomain) {
    if (!/^https?:\/\//.test(url)) {
        var currentHref_1 = location.href;
        var typecurrentHref_1 = location.href;
        var typeLocation_1 = window.location;
        if (url.indexOf("/") === 0) {
            ["hash", "search", "pathname"].forEach(function (key) {
                typecurrentHref_1 = currentHref_1.replace(typeLocation_1[key], "");
            });
            url = "" + currentHref_1 + url;
        }
        else if (url === "") {
            return typecurrentHref_1;
        }
        else {
            ["hash", "search"].forEach(function (key) {
                typecurrentHref_1 = currentHref_1.replace(typeLocation_1[key], "");
            });
            url = "" + typecurrentHref_1.replace(/\/[\w\d\.]*$/i, "/") + url;
        }
    }
    return exports.webLink(url, title, openMode, searchDomain);
};
